export const SIP_CONFIG = {
  server: process.env.REACT_APP_ASTERISK_WEBSOCKET_URL, // Asterisk WebSocket 서버 주소
  trace_sip: false,
};
